import { GitMerge, MoreVertical } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

interface ClientActionsMenuProps {
  canMerge: boolean
  onMerge: () => void
}

/**
 * SOLY-CUST-001 — client-header kebab, same pattern as ProjectActionsMenu: an item is HIDDEN (not
 * disabled) when the user lacks its permission, no destructive red (the safety lives in the
 * dialog), and nothing renders when nothing applies.
 */
export function ClientActionsMenu({ canMerge, onMerge }: ClientActionsMenuProps) {
  if (!canMerge) return null

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8" aria-label="Plus d'actions" data-testid="client-actions-menu-btn">
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuItem onSelect={onMerge} data-testid="client-merge-action">
          <GitMerge className="h-4 w-4" />
          Fusionner avec un autre client…
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
